import React, { Component } from 'react';
import {roundToTwo} from '../../Helpers/Helpers';

class FramedSize extends Component {

	componentDidUpdate(prevProps, prevState) {
        if ( prevProps.selectedFrame !== this.props.selectedFrame || prevProps.frameImageHeight !== this.props.frameImageHeight || prevProps.frameImageWidth !== this.props.frameImageWidth ) {
            this.getSelectedFrame();
        }
	}

	getSelectedFrame() {
		const {frameImageWidth, frameImageHeight, selectedFrame, framedCalc} = this.props;
		const dimensions = selectedFrame.get('dimensions');
		if (dimensions !== undefined) {
			const priceFrame = selectedFrame.get('price'); // Frame Price
			const frameWidthNew = parseFloat(frameImageWidth) + (parseFloat(dimensions.get('width')) * 2) + 0.5;
			const frameHeightNew = parseFloat(frameImageHeight) + (parseFloat(dimensions.get('width')) * 2) + 0.5;
			const frameFullDimension = parseFloat(frameImageWidth) + parseFloat(frameImageHeight); // Frame width + height

			let outputFrame = 0;
			if (frameFullDimension < 105)
				outputFrame = frameFullDimension * parseFloat(priceFrame);
			else if (frameFullDimension >= 105 && frameFullDimension < 140)
				outputFrame = (frameFullDimension * 0.16) + (frameFullDimension * parseFloat(priceFrame));
			else if (frameFullDimension >= 140 && frameFullDimension < 200)
				outputFrame = (frameFullDimension * 0.25) + (frameFullDimension * parseFloat(priceFrame));
			else if (frameFullDimension >= 200)
				outputFrame = (frameFullDimension * 0.33) + (frameFullDimension * parseFloat(priceFrame));

			// For adding additional price to style based on framed size
			const framedFullSize = roundToTwo(frameWidthNew) + roundToTwo(frameHeightNew)
			const framed_size = framedCalc.getIn(['acf', 'framed_size_pocm'])

			if (undefined !== framed_size) {
				for (var i = 0; i < framed_size.size; i++) {
					const w_h_from = framed_size.getIn([i, 'w_h_from_pocm'])
					const w_h_to = framed_size.getIn([i, 'w_h_to_pocm'])
					const rate = framed_size.getIn([i, 'rate_pocm'])
					if (parseFloat(framedFullSize) >= w_h_from && (parseFloat(framedFullSize) <= w_h_to || w_h_to === '')) {
						outputFrame = parseFloat(outputFrame) + parseFloat(rate);
						break;
					}
				}
			}
			// For adding additional price to style based on framed size

			this.props.dispatch({
                type: 'SET_STATE',
                state: {
					canvasFrameTotal: outputFrame.toFixed(2),
                    actualFrameSizeH: roundToTwo(frameHeightNew),
                    actualFrameSizeW: roundToTwo(frameWidthNew),
                    actualFrameFullDimension: frameFullDimension
                }
            })
		}
	}

  	render() {
  		const {actualFrameSizeH, actualFrameSizeW, selectedFrame} = this.props;
	    return (
	       <tr>
				<th>Framed Size</th>
				<td>
					{selectedFrame.size > 0 ? actualFrameSizeW + 'cm x ' + actualFrameSizeH + 'cm' : '-'}
				</td>
				<td></td>
            </tr>
	    );
  	}
}

export default FramedSize;